import { Maybe } from '@karakuri-web/faq-type'

export function value<T>(value: Maybe<T> | undefined, defaultValue: T) {
  if (!value) {
    return defaultValue
  }
  return value
}
export function values<T>(
  value: Maybe<readonly Maybe<T>[]> | undefined,
  defaultValue: readonly T[] = []
) {
  if (!value) {
    return defaultValue
  }
  return value.filter((v): v is T => !!v)
}
